import './bootstrap-modal.scss';

import { useState } from 'react';
import Modal, { ModalProps } from 'react-bootstrap/Modal';

import { ReactComponent as Close } from '../../assets/close-icon.svg';
import logo from '../../assets/ggzecademy-portaal-logo-h-no-padding.svg';
import questionMark from '../../assets/questionmark-icon.svg';
import styles from './Navbar.module.scss';

function MyVerticallyCenteredModal(props: ModalProps) {
  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">Hulp nodig?</Modal.Title>
        <button className="modal-close-button" onClick={props.onHide}>
          <Close />
        </button>
      </Modal.Header>
      <Modal.Body>
        <p>In deze artikelen lees je meer informatie:</p>

        <ul>
          <li>
            <a
              href="https://support.ggzecademy.nl/support/solutions/articles/23000009544-hoe-kan-ik-me-registreren-en-aanmelden-bij-centraal-leerplatform-ggz-ecademy-"
              target="_blank"
              rel="noreferrer"
            >
              Hoe kan ik me registreren en aanmelden bij Centraal leerplatform GGZ Ecademy?
            </a>
          </li>
          <li>
            <a
              href="https://support.ggzecademy.nl/support/solutions/articles/23000009569-hoe-neem-ik-contact-op-met-het-supportteam-"
              target="_blank"
              rel="noreferrer"
            >
              Hoe neem ik contact op met het supportteam?
            </a>
          </li>
          <li>
            <a
              href="https://support.ggzecademy.nl/support/solutions/articles/23000010283-ik-ben-mijn-wachtwoord-vergeten-wat-nu-"
              target="_blank"
              rel="noreferrer"
            >
              Ik ben mijn wachtwoord vergeten, wat nu?
            </a>
          </li>
        </ul>

        <p>
          Staat het antwoord daar niet tussen? Neem dan contact op met{' '}
          <a href="mailto:support@ggzecademy.nl">support@ggzecademy.nl</a>&nbsp;of kijk op{' '}
          <a href="http://support.ggzecademy.nl" target="_blank" rel="noreferrer">
            support.ggzecademy.nl
          </a>
          .
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button onClick={props.onHide} className="btn btn-primary">
          Sluiten
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default function Navbar() {
  const [modalShow, setModalShow] = useState(false);

  return (
    <div className={styles.navbar}>
      <div className={styles.inner}>
        <div className={styles.logo}>
          <a href="/">
            <img src={logo} alt="Logo van GGZ Ecademy" />
          </a>
        </div>
        <div className={styles.helpWrapper}>
          <button
            className={styles.helpButton}
            onClick={() => setModalShow(true)}
            aria-label="klik voor hulp"
          >
            <img src={questionMark} className={styles.helpImage} alt="vraagteken" />
          </button>

          <MyVerticallyCenteredModal show={modalShow} onHide={() => setModalShow(false)} />
        </div>
      </div>
    </div>
  );
}
